import axios from 'axios'
import layer from 'vue-layer'
import { getApiUrl } from '@/utils/index.js'
import qs from 'qs'

// create an axios instance
const service = axios.create({
  baseURL: getApiUrl(), // url = base url + request url
  withCredentials: false, // send cookies when cross-domain requests
  timeout: 60000, // request timeout
  headers: {
    'Content-Type': 'application/json'
  },
  transformRequest: [
    function (data, headers) {
      if (headers['Content-Type'] === 'application/x-www-form-urlencoded') {
        return qs.stringify(data)
      }
      return JSON.stringify(data)
    }
  ],
  paramsSerializer: function (params) {
    return qs.stringify(params, {
      arrayFormat: 'brackets'
    })
  }
})

// request interceptor
service.interceptors.request.use(
  (config) => {
    // do something before request is sent
    return config
  },
  (error) => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    const res = response.data || {}
    // if the custom code is not 20000, it is judged as an error.
    if (res.code === 200) {
      return res
    } else {
      layer.msg(res.msg || 'Error')
      return Promise.reject(new Error(res.message || 'Error'))
    }
  },
  (error) => {
    console.log(error)
    return Promise.reject(error)
  }
)

export default service
